import { get } from 'http';
import axiosGraphQL from './GraphQL/axiosGraphQL';
import {
  QUERY_GET_CUSTOMER_CHECKIN_BY_PLANT,
  QUERY_GET_ORDER_BILL_PAYMENT_LIST,
  QUERY_GET_ORDER_EXPORT_HDDT_LIST,
  QUERY_GET_PAYMENT_SUMMARY,
} from './GraphQL/Queries/paymentSummaryQuery';
import { VARIABLES_PAYMENT_SUMMARY } from './GraphQL/Variables/paymentSummary';
import { TEAM_TYPE } from 'interfaces/TeamSale/TeamSale';

export const PaymentSummaryApis = {
  getPaymentSummary: async (params: any): Promise<any> => {
    return axiosGraphQL.post('/graphql', {
      query: QUERY_GET_PAYMENT_SUMMARY,
      variables: VARIABLES_PAYMENT_SUMMARY.getListPaymentSummary(params),
    });
  },

  getDetailById: async (params: {
    sumPaymentId: any;
    customerId: any;
    teamTypeId?: any;
    teamId?: any;
    saleOrder: any;
    purchaseOrder: any;
  }): Promise<any> => {
    const {
      sumPaymentId,
      teamTypeId,
      teamId,
      customerId,
      saleOrder,
      purchaseOrder,
    } = params;
    return axiosGraphQL.post('/payment/bill-payment', {
      // sumPaymentId: 'TT20241129000005',
      // teamId: '5001TC000002',
      // customerId: '200000001',
      ...(sumPaymentId && { sumPaymentId }),
      ...(teamTypeId == TEAM_TYPE.stay && { teamTypeId }),
      ...(teamId && { teamId }),
      ...(customerId && { customerId }),
      ...(saleOrder && { saleOrder }),
      ...(purchaseOrder && { purchaseOrder }),
    });
  },

  savePaymentSumary: async (params: any): Promise<any> => {
    const {
      sumPaymentId,
      marketPrice,
      pnjpDebitAmount,
      pnjpDebitQ10,
      customerDebitAmount,
      customerDebitQ10,
      totalQ10,
      totalHaolai,
      totalUnitPrice,
      totalProcessPrice,
      totalGoldPrice,
      finalPrice,
      totalNote,
      codPrice,
      transferPrice,
      purchaseDeductOrder,
      processPriceDeduct,
      q10,
      voucher,
      note,
      customerDebitId,
      customerId,
      saleOrder,
      purchaseOrder,
      pnjpDebitAmountAfter,
      pnjpDebitQ10After,
      customerDebitAmountAfter,
      customerDebitQ10After,
      teamSaleId,
      orderType,
      purchaseType,
      type = 'DEB10_01', // Default type
      // Thêm 4 trường mới
      orderTotalPrice,
      orderTotalQ10,
      purchaseTotalPrice,
      purchaseTotalQ10,
    } = params;
    return axiosGraphQL.post('/payment/upsert-bill-payment', {
      ...(sumPaymentId && { sumPaymentId }),
      marketPrice: marketPrice || 0, // Luôn truyền marketPrice
      pnjpDebitAmount: pnjpDebitAmount || 0,
      pnjpDebitQ10: pnjpDebitQ10 || 0,
      customerDebitAmount: customerDebitAmount || 0,
      customerDebitQ10: customerDebitQ10 || 0,
      totalQ10: totalQ10 || 0,
      totalHaolai: totalHaolai || 0,
      totalUnitPrice: totalUnitPrice || 0,
      totalProcessPrice: totalProcessPrice || 0,
      totalGoldPrice: totalGoldPrice || 0,
      finalPrice: finalPrice || 0,
      ...(totalNote && { totalNote }),
      codPrice: codPrice || 0,
      transferPrice: transferPrice || 0,
      purchaseDeductOrder: purchaseDeductOrder || 0,
      processPriceDeduct: processPriceDeduct || 0,
      q10: q10 || 0,
      voucher: voucher || 0,
      ...(note && { note }),
      ...(customerId && { customerId }),
      ...(customerDebitId && { customerDebitId }),
      saleOrder: saleOrder || [],
      purchaseOrder: purchaseOrder || [],
      pnjpDebitAmountAfter: Number(pnjpDebitAmountAfter) || 0,
      pnjpDebitQ10After: Number(pnjpDebitQ10After) || 0,
      customerDebitAmountAfter: Number(customerDebitAmountAfter) || 0,
      customerDebitQ10After: Number(customerDebitQ10After) || 0,
      ...(teamSaleId && { teamSaleId }),
      purchaseAcYn: false,
      ...(orderType && { orderType }),
      ...(purchaseType && { purchaseType }),
      type: type, // Add type parameter
      // Thêm 4 trường mới vào request
      orderTotalPrice: orderTotalPrice || 0,
      orderTotalQ10: orderTotalQ10 || 0,
      purchaseTotalPrice: purchaseTotalPrice || 0,
      purchaseTotalQ10: purchaseTotalQ10 || 0,
    });
  },

  deletePaymentSummary: async (params: any): Promise<any> => {
    const { sumPaymentId } = params;
    return axiosGraphQL.delete(`/payment/delete-bill-payment/${sumPaymentId}`);
  },

  getCustomerCheckInByPlant: async (params: any): Promise<any> => {
    return axiosGraphQL.post('/graphql', {
      query: QUERY_GET_CUSTOMER_CHECKIN_BY_PLANT,
      variables: VARIABLES_PAYMENT_SUMMARY.getCustomerCheckInByPlant(params),
    });
  },

  getOrderBillPaymentList: async (params: any): Promise<any> => {
    return axiosGraphQL.post('/graphql', {
      query: QUERY_GET_ORDER_BILL_PAYMENT_LIST,
      variables: VARIABLES_PAYMENT_SUMMARY.getOrderBillPaymentList(params),
    });
  },

  getOrderExportHDDTList: async (sumPaymentId: string): Promise<any> => {
    return axiosGraphQL.post('/graphql', {
      query: QUERY_GET_ORDER_EXPORT_HDDT_LIST,
      variables: {
        input: {
          sumPaymentId: sumPaymentId,
        },
      },
    });
  },

  exportExcel: async (params: any): Promise<any> => {
    // console.log('params', params);
    try {
      const response: any = await axiosGraphQL.post(
        '/print/printExcel',
        {
          printFunctionId: 'pr10000004',
          params: [
            {
              key: 'paymentid',
              value: params.sumPaymentId,
            },
          ],
          orientation: 'portrait',
          pageSize: 'A4',
        },
        {
          responseType: 'blob',
        },
      );

      const blob = new Blob([response], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const objectURL = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = objectURL;
      a.download = params?.fileName || 'PaymentSummary';

      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(objectURL);
    } catch (error) {
      console.error(error);
    }
  },

  exportPDF: async (params: any): Promise<any> => {
    // console.log('params', params);
    try {
      const response: any = await axiosGraphQL.post(
        '/print/printPdf',
        {
          printFunctionId: 'pr10000004',
          params: [
            {
              key: 'paymentid',
              value: params.sumPaymentId,
            },
          ],
          orientation: 'portrait',
          pageSize: 'A4',
        },
        {
          responseType: 'blob',
        },
      );

      const blob = new Blob([response], {
        type: 'application/pdf',
      });

      const objectURL = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = objectURL;
      a.download = params?.fileName || 'PaymentSummary';

      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(objectURL);
    } catch (error) {
      console.error(error);
    }
  },
};
